import { createBaseService } from '~/services/base.axios.service.js'

const service = createBaseService(() => ({}), import.meta.env?.VITE_PASSPORT_BASE_URL)

export default service
